export const Logo = ({ compact = false }) => (
  <div className="flex items-center gap-2.5" data-testid="brand-logo">
    <svg width="46" height="46" viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <defs>
        <linearGradient id="mhaShield" x1="18" y1="26" x2="46" y2="55" gradientUnits="userSpaceOnUse">
          <stop stopColor="#E9C766" />
          <stop offset="1" stopColor="#A07E1F" />
        </linearGradient>
      </defs>
      <path d="M18 27h28v10.5c0 9.4-9.1 15.6-14 17.6-4.9-2-14-8.2-14-17.6V27z" fill="url(#mhaShield)" />
      <path d="M32 5.5 60.5 17 32 28.5 3.5 17 32 5.5z" fill="#12294D" />
      <path d="M21 20.5v7.5c0 3 4.9 5.2 11 5.2s11-2.2 11-5.2v-7.5l-11 4.4-11-4.4z" fill="#12294D" opacity="0.92" />
      <path d="M60.5 17v11.5" stroke="#12294D" strokeWidth="2.2" strokeLinecap="round" />
      <circle cx="60.5" cy="32.5" r="3.2" fill="#12294D" />
      <text x="32" y="43.5" textAnchor="middle" fontFamily="Outfit, sans-serif" fontWeight="700" fontSize="16" fill="#FFFFFF">My</text>
    </svg>
    {!compact && (
      <div className="leading-none">
        <p className="text-[19px] font-bold tracking-tight text-[#12294D]" style={{ fontFamily: "'Outfit', sans-serif" }}>
          Homework<span className="text-[#A07E1F]">Assist</span>
        </p>
        <p className="mt-1 font-mono-accent text-[9px] uppercase tracking-[0.32em] text-[#A07E1F]">
          .online
        </p>
      </div>
    )}
  </div>
);
